import React, {useCallback, useMemo} from 'react';
import {Link} from 'react-router-dom';


import {USER_TABS} from 'src/constants';
import {ACCESS_RIGHTS, useAdminAccessRight} from 'src/hooks/access-rights';
import {useEventTracking} from 'src/hooks/useEventTracking';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';

type Props = {
    userId: number,
    caption: string,
    blank?: boolean,
    route?: string,
    place: string,
};

export const UserLink: React.FC<Props> = props => {
    const {userId, caption, blank, route, place} = props;
    const {hasAccess} = useAdminAccessRight();
    const {userProfileOpen} = useEventTracking();

    const linkIsAvailable = useMemo(
        () => hasAccess(ACCESS_RIGHTS.USER_SCREEN_VIEW),
        [hasAccess],
    );

    const content = (
        <EllipsisTextHint title={caption}>
            {caption}
        </EllipsisTextHint>
    );

    const onTrackUserProfileOpen = useCallback(() => {
        userProfileOpen({place});
    }, [place, userProfileOpen]);

    return linkIsAvailable ? (
        <Link
            to={`/profile/user/${userId}/${route || USER_TABS.DETAILS.name}`}
            onClick={onTrackUserProfileOpen}
            target={blank ? '_blank' : undefined}>
            {content}
        </Link>
    ) : content;
};
